import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-4xl animate-bounce">🦉</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/panel" replace />;
  return children;
}
